import './index.sass';

export default () => {
    console.log('init jobs');
}